/* TAG Comics: site-wide behaviour (menu, search, add to cart without leaving the page). */
(function(){
  var $=function(id){return document.getElementById(id)};

  var menuBtn=$('menuBtn'),nav=$('nav');
  if(menuBtn&&nav){
    menuBtn.addEventListener('click',function(){var o=nav.classList.toggle('open');menuBtn.setAttribute('aria-expanded',o)});
    nav.addEventListener('click',function(e){if(e.target.closest('a')){nav.classList.remove('open');menuBtn.setAttribute('aria-expanded',false)}});
  }

  var sBtn=$('searchBtn'),sBar=$('searchBar');
  if(sBtn&&sBar){
    sBtn.addEventListener('click',function(){var on=sBar.hidden;sBar.hidden=!on;sBtn.setAttribute('aria-expanded',on);if(on)$('q').focus()});
  }

  function setCount(n){var c=$('cartCount');if(!c)return;c.textContent=n;c.hidden=!n;var l=$('cartLink');if(l)l.setAttribute('aria-label','Cart, '+n+(n===1?' item':' items'))}

  /* Add-to-cart forms marked data-ajax stay on the page and show a confirmation. */
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f.matches||!f.matches('form[data-ajax-cart]'))return;
    var sub=e.submitter;
    if(sub&&sub.name==='buy_now')return; /* buy now: let it go straight to checkout */
    if(!window.fetch)return;
    e.preventDefault();
    var btn=f.querySelector('[type=submit]'),msg=f.querySelector('.cart-msg'),label=btn?btn.innerHTML:'',label2='';
    if(btn){btn.disabled=true}
    fetch(window.TAG.cartAdd+'.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(d){if(!r.ok)throw d;return d})})
      .then(function(){return fetch(window.TAG.cartUrl+'.js').then(function(r){return r.json()})})
      .then(function(cart){
        setCount(cart.item_count);
        if(msg){msg.className='msg ok cart-msg';msg.innerHTML='Added to your cart. <a href="'+window.TAG.cartUrl+'" style="text-decoration:underline">View cart</a>'}
        else if(btn){label2='Added ✓'}
      })
      .catch(function(err){
        var t=(err&&err.description)||'That could not be added. Please try again.';
        if(msg){msg.className='msg err cart-msg';msg.textContent=t}else{alert(t)}
      })
      .then(function(){
        if(!btn)return;btn.disabled=false;
        if(label2){btn.innerHTML=label2;setTimeout(function(){btn.innerHTML=label},2200)}else{btn.innerHTML=label}
      });
  });
})();
